import Config from '../../config';
import { QueryKeys, useCustomQuery } from './index';

export type CountryDto = {
  countryCode: string;
  countryName: string;
  countryDescription: string;
  currencyCode: string;
}

export const useCountriesList = () => useCustomQuery<CountryDto[]>(
  [QueryKeys.countries.CountriesList],
  {
    url: Config.endpoints.FETCH_COUNTRIES,
    errorMessage: 'Fetching countries failed',
    defaultData: [],
  }
);
